import { useState, useEffect } from 'react';
import { getTopCV, ICandidate, ICandidateCVs } from 'wisestep-api';

const useCandidateCV = (candidate: ICandidate) => {
  const [cvs, setCVS] = useState<ICandidateCVs[]>([]);
  useEffect(() => {
    if (!candidate?.candidateId && !candidate?.id) {
      setCVS([]);
      return;
    }

    const fetchCVOptions = async () => {
      try {
        const res = await getTopCV(candidate.candidateId ?? candidate?.id ?? '');
        setCVS(res?.data);
      } catch (error) {
        console.error('Error fetching CV options:', error);
        setCVS([]);
      }
    };

    fetchCVOptions();
  }, [candidate?.candidateId, candidate?.id]);

  return [cvs];
};

export default useCandidateCV;
